import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-payment-plan-installment',
  templateUrl: './payment-plan-installment.component.html',
  styleUrls: ['./payment-plan-installment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentPlanInstallmentComponent implements OnInit {

  @Input() amount: string;
  @Input() dueDate?: string;
  @Input() index?: number;
  @Input() isUpfrontAmount: boolean;
  @Input() dueInFull: boolean;
  @Input() itemized: boolean;
  @Input() termSelectionDisabled?: boolean;

  constructor() { 
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
  }

  ngOnInit(): void {
  }

}
